import React, { useEffect, useState } from 'react'

import {Trans} from '@lingui/macro'
import {Button} from 'components/UI/Button/Button'
import {useDispatch, useSelector} from 'react-redux'

import {IdZreportsState, typeZreportsFilters} from 'model/dashboardZreports/dZreportReducer';
import {  dZReportsSetFiltersAC } from 'model/dashboardZreports/dZreportsActionCreators';
import {InputText} from 'components/UI/InputText/InputText';

import { logoutSagaAC } from 'model/system/systemActionCreators';
import { getStoreList } from 'model/dashboardStores/dStoresAPI';
import { NULL_VALUE, SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox';
import { Loader } from 'components/UI/Loader/Loader';
import DateFilter from 'components/UI/DateFilter/DateFilter';


// Type
export type typeDZreportsFilters = {
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const DZreportsFilters: React.FC<typeDZreportsFilters> = ({setOpenFilterBar, setIsActiveFilters}) => {

    const dispatch = useDispatch()

    const filters = useSelector((state: { dZReports: IdZreportsState }) => state.dZReports.filters)


    // Did mount
    useEffect(() => {
        setLoaderStore(true)
        const setData = async () => {

            let responseStores = await getStoreList({ filters: { name: null }, full: false })

            if (responseStores.status === 200) {
                const newStoresList = [ ...selectStoreList, ...responseStores.data ]
                setSelectStoreList(newStoresList)
            } else if (responseStores.status === 401) {
                dispatch(logoutSagaAC())
            }
            setLoaderStore(false)
        }

        setData()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (filters.storeId) {
            setStoreIdValue(filters.storeId)
        }
    }, [ filters ])

    // Store's Id input
    const [ storeIdValue, setStoreIdValue ] = useState<string>(() => filters.storeId || '')
    const [ selectStoreList, setSelectStoreList ] = useState<typeValuesListItem[]>([])
    const [loaderStore, setLoaderStore] = useState(false)

    //fiscalCardId Input
    const [fiscalCardIdValue, setFiscalCardId] = useState(filters.fiscalCardId?  filters.fiscalCardId : '')
    const onChangeFiscalCardId = (e: any) => {
        setFiscalCardId(e.target.value)
    }

    //terminalSerianNumber Input
    const [terminalSNValue, setTerminalSN] = useState(filters.terminalSerianNumber? filters.terminalSerianNumber : '')
    const onChangeTerminalSN = (e: any) => {
        setTerminalSN(e.target.value)
    }

    // Close Date

    const [toValue, setToValue] = useState(filters.closeDate?.to ? filters.closeDate.to.substring(0, 10) : '')

    // Open Date
    const [fromValue, setFromValue] = useState(filters.closeDate?.from ! ? filters.closeDate.from.substring(0, 10) : '')


    const checkIsChangedFiltersHandler = (newFilters: typeZreportsFilters  ) : boolean => {
        // eslint-disable-next-line eqeqeq
        return !(newFilters.fiscalCardId == filters.fiscalCardId && newFilters.terminalSerianNumber== filters.terminalSerianNumber && newFilters.storeId === filters.storeId
            // eslint-disable-next-line eqeqeq
            && newFilters.closeDate?.to == filters.closeDate?.to && newFilters.closeDate?.from == filters.closeDate?.from)
    }


// Submit form
    const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        let a = fromValue ? (new Date(fromValue).toISOString()).slice(0, -1) : null
        let b = toValue ? (new Date(toValue).toISOString()).slice(0, 11) + '23:59:59:99.999' : null

        const newFilters: typeZreportsFilters = {
            closeDate: (a === '' && b === '') ? null : {
                from: a,
                to: b
            },
            fiscalCardId: fiscalCardIdValue.trim()===''? null : fiscalCardIdValue.trim(),
            terminalSerianNumber:  terminalSNValue.trim()===''? null : terminalSNValue.trim(),
            storeId: storeIdValue === NULL_VALUE.id ? null : storeIdValue
        }
        if(checkIsChangedFiltersHandler(newFilters)){
            await dispatch(dZReportsSetFiltersAC(newFilters))
            setIsActiveFilters(true)
        }


        setOpenFilterBar(false)

    }

    const onRestoreHandler = () => {

        setToValue('')
        setFromValue('')
        setFiscalCardId('')
        setTerminalSN('')
        setStoreIdValue(NULL_VALUE.id)
        setIsActiveFilters(false)
        dispatch(dZReportsSetFiltersAC({ closeDate: null ,
                                           fiscalCardId: null,
                                           terminalSerianNumber:  null,
                                           storeId: null}))
    }

    return (
        <>
            <form onSubmit={(e) => onSubmitHandler(e)}>
                <div className="flex flex-col gap-4">
                    <div className={'relative'}>
                        <SelectBox
                            label={<Trans>Store</Trans>}
                            valuesList={selectStoreList}
                            valueId={storeIdValue}
                            setIdValue={setStoreIdValue}
                            labelClassname="text-left"
                        />
                        {loaderStore && <Loader/>}
                    </div>
                    <div>
                        <InputText id={"fiscalCardId"} label={<Trans>Fiscal card Id</Trans>}
                                   onChange={onChangeFiscalCardId} value={fiscalCardIdValue}
                                   maxLength={100}/>
                    </div>
                    <div>
                        <InputText id={"terminalSerianNumber"} label={<Trans>Terminal Serial Number</Trans>}
                                   onChange={onChangeTerminalSN} value={terminalSNValue}
                                   maxLength={100}/>
                    </div>


                    <DateFilter
                        label={<Trans>Close date</Trans>}
                        fromValue={fromValue}
                        setFromValue={setFromValue}
                        toValue={toValue}
                        setToValue={setToValue}
                        maxData={`${(new Date()).getUTCFullYear()}-${((new Date()).getUTCMonth() + 1) > 9 ? (new Date()).getUTCMonth() + 1 : '0'+((new Date()).getUTCMonth() + 1) }-${(new Date()).getUTCDate()}`}
                        minData={'2020-01-01'}
                    />


                    <div className="flex flex-col sm:flex-row gap-4 mt-4">
                        <Button buttonClassName="w-full" secondary={true} type="button" label={<Trans>Clear</Trans>}
                                onClick={onRestoreHandler}/>
                        <Button buttonClassName="w-full" type="submit" label={<Trans>Apply</Trans>}/>
                    </div>

                </div>
            </form>
        </>
    )
}
